import { instanceApi } from '../../../services';

export const getReports = (params: any): Promise<any> => instanceApi.get(`rebate/report/getcommissionbyclientreport`, { params });

export const sendEmail = (data: any): Promise<any> => instanceApi.post('rebate/report/sendemailcommissionsclientbyrequestid', data);
